import { IMyLinkTalentInfo } from 'pages/MyLinks/types';
import { CONFIG } from 'shared/config';
import { IProfileLink } from 'shared/interfaces/IProfile';

export const profileListLinkSetter = (profileLink: IProfileLink, talentInfo: IMyLinkTalentInfo) => {
  const startLink = CONFIG?.TALENT_APP_URL || `https://talent.test.castingapp.com`;
  const isRepresented = profileLink?.representation_type === 'agency_representation' ? true : false;
  const country_code = isRepresented
    ? profileLink?.agency?.primary_address?.country_code || profileLink?.agency?.contact_country_code || 'not-available'
    : talentInfo?.talent_country_code || 'not-available';
  const talent_slug = talentInfo?.talent_slug || 'no-slug';
  const agency_slug = isRepresented ? profileLink?.agency?.slug : 'non-represented';
  const division_id = profileLink?.division ? profileLink?.division?.id : '';
  const base_url = `${startLink}/${country_code.toLowerCase()}/${talent_slug}/${agency_slug}`;
  const urlLink = isRepresented && division_id ? `${base_url}?division_id=${division_id}` : base_url;

  return urlLink;
};
